import { render, staticRenderFns } from "./PlatformAdvertStairSwiper.vue?vue&type=template&id=28944ab4&scoped=true&"
import script from "./PlatformAdvertStairSwiper.vue?vue&type=script&lang=js&"
export * from "./PlatformAdvertStairSwiper.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAdvertStairSwiper.vue?vue&type=style&index=0&id=28944ab4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28944ab4",
  null
  
)

export default component.exports